// for me new
// ticket table data wala

import React, { Component } from "react";
import "./TicketTableHeader";
import Config from "../../config";
import Axios from "axios";
import { DatePicker, Row, Spin, Col, Input, Tooltip } from "antd";
import { Form } from '@ant-design/compatible';
import { ColumnsType, TableProps } from 'antd/es/table';
import $, { post } from "jquery";
import PreviousIcon from "./PreviousIcon.png";
import NextIcon from "./NextIcon.png";
import paginationDecrement from "./paginationDecrement.png";
import paginationIncrement from "./paginationIncrement.png";
import DownloadIcon from "./DownloadIcon.png";
import CrossIcon from "./CrossIcon.png";
import SearchIcon from "./SearchIcon.png";
// import '../memberSearch/Incidents/Incidents.css'
import ExportJsonExcel from "js-export-excel";
//import ErrorBoundaries from '../../ErrorBoundaries';
import { addTab, authListObject, addTicketDetailTab } from "../../store/broadcaster/BroadcastRegister";
import Postdata from "../Pages/Postdata";
//import AddEventBlock from "../memberSearch/Incidents/AddEventBlock";

export class TicketTableData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnHeaders: [
        "Created Date",
        "Ticket ID",
        "Ticket Type",
        "Created For",
        "Created For ID",
        "Created By",
        "Status",
        // "Auth",
        // "Mode",
        // "DX",
      ],
      // currentPage, upperPageBound, lowerPageBound, isPrevBtnActive, isNextBtnActive,
      HitSearch: false,
      ActiveBt: true,
      filterTicketID: "",
      filterTicketType: "",
      filterTicketStatus: "",
      filterCreatedBy: "",
      filterReq: "",
      filterAbv: "",
      filterReference: "",
      filterSubId: "",
      filterCreatedFor:"",
      filterCreatedForID: "",
      filterMemberName: "",
      filterCreatedDate: "",
      filterStatus: "",
      filterCreatedBy:"",
      filterPos: "",
      filterAuth: "",
      filterMode: "",
      filterDx: "",
      authListData: [],
      filterData: [],
      authListLoading: false,
      getNpi: sessionStorage.getItem("npivalue"),
      getPlanName: sessionStorage.getItem("planName"),
      gettaxId: sessionStorage.getItem("taxid"),
      searchColumn: "",
   //   pageNumber: 2,
      totalPages: "",
      // pageSize: 15,
      totalRecords: "",
      totalRecordFound: "",

      currentPage: 1,
      tempPage: 1,
      todosPerPage: 15,
      upperPageBound: 5,
      lowerPageBound: 0,
      isPrevBtnActive: "disabled",
      isNextBtnActive: "",
      pageBound: 1,
      id: "",
      pageBound: 1,
      filterPageNumber: 1,
      // serialNumber : ""
      pageStatus: false,
      memberDetailsSubscriberId: "",
      authPage:
        this.props.activetab === undefined ||
          this.props.activetab === null ||
          this.props.activetab === ""
          ? "1"
          : this.props.activetab,
      tabName: "authList",
      //--------------------
      //  our state
      TenantID: sessionStorage.getItem("Tanent"),
      // "TenantID": 100,
      CreatedDate: null,
      TicketID: null,
      TicketType: null,
      CreatedFor: null,
      CreatedForID: null,
      CreatedBy: null,
      Status: null,
      NpiDetails: sessionStorage.getItem("npivalue") !== null ? JSON.parse(
        sessionStorage.getItem("npivalue")
      ) : [],
      TaxDetails: sessionStorage.getItem("taxid") !== null ? JSON.parse(
        sessionStorage.getItem("taxid")
      ) : [],
      TAXIDNPIMapping: sessionStorage.getItem("taxidNpiMapping") !== null ? JSON.parse(
        sessionStorage.getItem("taxidNpiMapping")
      ) : [],
      Roles: sessionStorage.getItem("rolename").split(','), 
      QueueID: null,
      SortTerm: null,
      IsAscending: false,
      PageNumber: 1,
      PageSize: 15,
      IsActive: true,
      StopCall: true,
      StopCallForSidebar: true,
    //  clickActive: true,
    };
    window.addEventListener("apiCallSuccess", this.getAuthorizationsList);
  }
  getAuthorizationsList = (
     value,
    // value1,
    // value2,
    // value3,
    // value4,
    // value5,
    // value6
  ) => {
   console.log("ourvalue",value)
   console.log("currentPage shiv ",this.state.currentPage)

    // this.setState({
    //   currentPage:
    //     this.state.pageStatus === value ? this.state.currentPage : value1,
    //   upperPageBound: value2,
    //   lowerPageBound: value3,
    //   pageBound: value4,
    //   // isPrevBtnActive : value5,
    //   // isNextBtnActive : value6
    // });

    // console.log("subscriber id ", this.state.memberDetailsSubscriberId);

    var postData1 = {
      // SearchParameter: {
      //   // NPI: this.state.getNpi,
      //   // TaxID: this.state.gettaxId,
      //   // subscriberid: "aaa"
      // },
      // PlanName: this.state.getPlanName,
      // PageNumber: this.state.pageStatus != value ? 1 : this.state.currentPage,
      // // PageNumber :this.state.currentPage,
      // PageSize: this.state.todosPerPage,
      // RequestType: this.state.filterReq,
      // Abbrevation: this.state.filterAbv,
      // ReferenceNumber: this.state.filterReference,
      // SubscriberID: this.state.filterSubId,
      // MemberName: this.state.filterMemberName,
      // ExpectedDOS: this.state.filterDOS,
      // AuthStatus: this.state.filterStatus,
      // PosAbb: this.state.filterPos,
      // AuthorizationType: this.state.filterAuth,
      // Entry: this.state.filterMode,
      // PrimaryDx: this.state.filterDx,
      TenantID: this.state.TenantID,
      CreatedDate: this.state.filterCreatedDate,
      TicketID: this.state.filterTicketID,
      TicketType: this.state.filterTicketType,
      CreatedFor: this.state.filterCreatedFor,
      CreatedForID: this.state.filterCreatedForID,
      CreatedBy: this.state.filterCreatedBy,
      Status: this.state.filterTicketStatus,
      NpiDetails: this.state.NpiDetails,
      TaxDetails: this.state.TaxDetails,
      TAXIDNPIMapping: this.state.TAXIDNPIMapping,
      Roles: this.state.Roles,
      QueueID: this.props.selectedSidebar ? this.props.selectedSidebar : this.state.QueueID,
      SortTerm: this.state.SortTerm,
      IsAscending: this.state.IsAscending,
      PageNumber: this.state.PageNumber,
      PageSize: this.state.PageSize,
      IsActive: this.state.IsActive,
    };
    var postData2 = {
      TenantID: this.state.TenantID,
      CreatedDate: this.state.CreatedDate,
      TicketID: this.state.TicketID,
      TicketType: this.state.filterTicketType,
      CreatedFor: this.state.filterCreatedFor,
      CreatedForID: this.state.filterCreatedForID,
      CreatedBy: this.state.filterCreatedBy,
      Status: this.state.filterTicketStatus,
      NpiDetails: this.state.NpiDetails,
      TaxDetails: this.state.TaxDetails,
      TAXIDNPIMapping: this.state.TAXIDNPIMapping,
      Roles: this.state.Roles,
      QueueID: this.props.selectedSidebar ? this.props.selectedSidebar : this.state.QueueID,
      SortTerm: this.state.SortTerm,
      IsAscending: this.state.IsAscending,
      PageNumber: this.state.PageNumber,
      PageSize: this.state.PageSize,
      IsActive: false,
    };
    // // calling = () =>{
     let postData;
        this.props.clickActive ? postData = postData1 :  postData = postData2;
    // }
  //  console.log("we achieved ", this.props.clickActive);
    //   console.log("falsss");
    // var postData = postData1;
    // }else{
    //   console.log("came here");
    //   var postData = postData2;
    // }
    //var postData = postData1;
   // var postData = postData1

    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };

    Axios.post(Config.Ticket + "/GetTickets", postData, axiosConfig)
      .then((res) => {
    //    console.log("detaaa",res.data.Tickets);
        // Axios.get(Config.api + "/GetAllAuthorizations", axiosConfig).then((res) => {
        if (
          res.data.Tickets.length != 0 ||
          res.data.Tickets != null ||
          res.data.Tickets != undefined ||
          res.data.Tickets != ""
        ) {
          this.setState({
            authListData: res.data.Tickets,
            totalPages: res.data.TotalPages,
            totalRecords: Math.ceil(
              res.data.TotalRecords / this.state.PageSize
            ),
            authListLoading: true,
            filterData : this.state.filterData,
            totalRecordFound: res.data.TotalRecords,
          });
        } else {
          this.setState({
            authListData: [],
            authListLoading: true,
          });
        }
        // if (value === "downloadExcel") {
        //   let data = res.data.Tickets;
        //   let option = {};
        //   let dataTable = [];
        //   if (data.length > 0) {
        //     if (data) {
        //       for (let i in data) {
        //         let obj = {
        //           TicketID: data[i].TicketID,
        //           Req: data[i].Req,
        //           Abv: data[i].Abv,
        //           Reference: data[i].Reference,
        //           SubId: data[i].SubId,
        //           MemberName: data[i].MemberName,
        //           DOS: data[i].DOS,
        //           Status: data[i].Status,
        //           POS: data[i].POS,
        //           Auth: data[i].Auth,
        //           Mode: data[i].Mode,
        //           DX: data[i].DX,
        //         };
        //         dataTable.push(obj);
        //       }
        //     }
        //   }
        //   option.fileName = "Auth List";
        //   option.datas = [
        //     {
        //       sheetData: dataTable,
        //       sheetName: "Auth List",
        //       sheetHeader: [
        //         "TicketID",
        //         "TicketType",
        //         "Req",
        //         "Abv",
        //         "Reference",
        //         "Sub ID",
        //         "Member Name44",
        //         "D.O.S",
        //         "Status",
        //         "POS",
        //         "Auth",
        //         "Mode",
        //         "DX",
        //       ],
        //     },
        //   ];
        //   let toExcel = new ExportJsonExcel(option);
        //   toExcel.saveExcel();
        // }
        this.updateRender();
      })
      .catch((err) => {
      //  console.log(err);
        this.setState({
          authListData: [],
          authListLoading: true,
        });
      });
  };
  updateRender = () => {
    // Force update the component to trigger a re-render
    this.forceUpdate();
  };

  componentDidMount() {
    this.getAuthorizationsList(
      // false,
      // this.state.currentPage,
      // this.state.upperPageBound,
      // this.state.lowerPageBound,
      // this.state.pageBound,
      // this.state.isPrevBtnActive,
      // this.state.isNextBtnActive
    );
    return () => {
      window.removeEventListener("apiCallSuccess", this.callApi);
    };
   // this.props.clickActive ? this.calling() : this.calling();
  }
  
   componentDidUpdate() {

   if(this.props.clickActive == false && this.state.StopCall == true){
  //  this.setState({PageNumber: 1,})
   // this.getAuthorizationsList();
   this.setState({PageNumber: 1}, ()=>{
    this.getAuthorizationsList();
   });
    this.setState({
      StopCall: false,
    })
   }
   if(this.props.clickActive == true && this.state.StopCall == false){
    this.setState({PageNumber: 1}, ()=>{
      this.getAuthorizationsList();
     });
    this.setState({
     // PageNumber: 1,
      StopCall: true,
    })
  //  console.log("andar agae");
   }
   if(this.props.selectedSidebar && this.state.StopCallForSidebar !== this.props.selectedSidebar){
   console.log("comeinnn again")
  // this.setState({PageNumber: 1,})
  this.setState({
    currentPage:1,
   // PageNumber:1,
  })
  this.setState({PageNumber: 1}, ()=>{
    this.getAuthorizationsList();
   });
    this.setState({
      // currentPage:1,
   //   PageNumber: 1,
      StopCallForSidebar: this.props.selectedSidebar,
    })
   }
   if(this.props.selectedSidebar == undefined && this.state.StopCallForSidebar !== this.props.selectedSidebar)
     {
      console.log("comeinnn again")
      this.setState({
      PageNumber: 1,
      currentPage: 1,
        QueueID: null,
        StopCallForSidebar: this.props.selectedSidebar,
      })
      //this.getAuthorizationsList();
      this.setState({PageNumber: 1}, ()=>{
        this.getAuthorizationsList();
       });
     }
     $("ul li.active").removeClass('active');
     $('ul li#' + this.state.currentPage).addClass('active');
   
   }
  filterOnchange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      HitSearch: true,
      [name]: value,
      // currentPage : 1
    });
  };

  columnAscendingOrder = (event, sortKey) => {
    const data = this.state.authListData;
    if(sortKey == "TicketID"){
    data.sort((a, b) => {
      const a1 = "";
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      return a1.localeCompare(b1);
    });
  }else{
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      return a1.localeCompare(b1);
    });
  }
    this.setState({ data });
  };

  ColumnDescendingOrder = (event, sortKey) => {
    const data = this.state.authListData;
    if(sortKey == "TicketID"){
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = "";
      return b1.localeCompare(a1);
    });
  }
  else{
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      return b1.localeCompare(a1);
    });
  }
    this.setState({ data });
  };

  dosOnChange = (date, dateString) => {
   //  console.log("val date",dateString)
    this.setState({
      HitSearch: true,
      filterCreatedDate: dateString,
    });
  };

  tableHeader = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <thead>
        <tr>
          <th>
            <div style={{ marginTop: "-30px" }}>
              <div>#</div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[0]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "CreatedDate")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "CreatedDate")}
                  ></div>
                </div>
              </div>
              <div>
                {getFieldDecorator("filterCreatedDate", {
                  initialValue:
                    this.state.filterCreatedDate != "" || this.state.filterCreatedDate != null
                      ? this.state.filterCreatedDate
                      : "",
                })(
                  <DatePicker
                    size="small"
                   // suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.dosOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
              </div>
              {/* <div>
                <Input
                  className="inputStyle"
                  name="filterReq"
                  type="text"
                  value={this.state.filterReq}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  size="small"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div> */}
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[1]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "TicketID")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "TicketID")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterTicketID"
                  type="text"
                  value={this.state.filterTicketID}
                  maxLength={100}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[2]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "TicketType")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "TicketType")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterTicketType"
                  type="text"
                  value={this.state.filterTicketType}
                  maxLength={100}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[3]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "CreatedFor")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "CreatedFor")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterCreatedFor"
                  type="text"
                  maxLength={250}
                  value={this.state.filterCreatedFor}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[4]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "CreatedForID")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "CreatedForID")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterCreatedForID"
                  type="text"
                  value={this.state.filterCreatedForID}
                  maxLength={250}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div style={{ marginTop: "-8px" }}>
                  {this.state.columnHeaders[5]}
                </div>
                <div style={{ marginTop: "-10px" }}>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "CreatedBy")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "CreatedBy")}
                  ></div>
                </div>
              </div>
              {/* <div>
                {getFieldDecorator("filterDOS", {
                  initialValue:
                    this.state.filterDOS != "" || this.state.filterDOS != null
                      ? this.state.filterDOS
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.dosOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
              </div> */}
               <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterCreatedBy"
                  type="text"
                  value={this.state.filterCreatedBy}
                  maxLength={250}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          <th>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[6]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "TicketStatus")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "TicketStatus")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterTicketStatus"
                  type="text"
                  value={this.state.filterTicketStatus}
                  onChange={this.filterOnchange}
                  maxLength={100}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.getAuthorizationsList(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
        </tr>
      </thead>
    );
  };

  getAuthDetails = (user) => {
    // console.log("user list details ", user);
    this.props.getDetails(user);
  };

  // handleClick = (event) => {
  //   // console.log("event",event.target.id);
  //   // console.log("pgg",this.state.currentPage);
  //   let listid = Number(event.target.id);
  //  console.log("page",typeof(event.target.id))
  //   this.setState(
  //     {
  //       PageNumber: parseInt(event.target.id),
  //       // currentPage: event.target.id,
  //       // StartIndex : event.target.id == 1 ? 0 : event.target.id > 1 ? this.state.currentPage * 15 : 0,
  //       // filterPageNumber : listid
  //       // todosPerPage: 20,
  //       pageStatus: false,
  //     },
  //     () => {
  //       this.setPrevAndNextBtnClass(listid);
  //       this.getAuthorizationsList(
  //         // false,
  //         this.state.currentPage,
  //         this.state.upperPageBound,
  //         this.state.lowerPageBound,
  //         this.state.pageBound,
  //         this.state.isPrevBtnActive,
  //         this.state.isNextBtnActive
  //       );
  //     }
  //   );
  //   $("ul li.active").removeClass("active");
  //   $("ul li#" + listid).addClass("active");
  // };

  // setPrevAndNextBtnClass = (listid) => {
  //  // console.log("listid",listid)
  //   var totalPage;

  //   totalPage = this.state.totalRecords;
  //   // console.log("total pages ",this.state.totalRecords)
  //   // console.log("total record ",this.state.totalRecordFound)

  //   this.setState({
  //     isNextBtnActive: "disabled",
  //     pageStatus: false,
  //   });
  //   this.setState({ isPrevBtnActive: "disabled" });
  //   if (totalPage === listid && totalPage > 1) {
  //     this.setState({ isPrevBtnActive: "" });
  //   } else if (listid === 1 && totalPage > 1) {
  //     this.setState({ isNextBtnActive: "" });
  //   } else if (totalPage > 1) {
  //     this.setState({ isNextBtnActive: "" });
  //     this.setState({ isPrevBtnActive: "" });
  //   }
  // };

  // btnIncrementClick = () => {
  //   this.setState({
  //     upperPageBound: this.state.upperPageBound + this.state.pageBound,
  //   });
  //   this.setState({
  //     lowerPageBound: this.state.lowerPageBound + this.state.pageBound,
  //   });
  //   let listid = this.state.upperPageBound + 1;
  //   this.setState({ currentPage: listid }, () => {
  //     this.setState({
  //       pageStatus: false,
  //     });
  //     this.setPrevAndNextBtnClass(listid);
  //     this.getAuthorizationsList(
  //       false,
  //       this.state.currentPage,
  //       this.state.upperPageBound,
  //       this.state.lowerPageBound,
  //       this.state.pageBound,
  //       this.state.isPrevBtnActive,
  //       this.state.isNextBtnActive
  //     );
  //   });
  // };

  // btnDecrementClick = () => {
  //   this.setState({
  //     upperPageBound: this.state.upperPageBound - this.state.pageBound,
  //   });
  //   this.setState({
  //     lowerPageBound: this.state.lowerPageBound - this.state.pageBound,
  //   });
  //   let listid = this.state.upperPageBound - 5;
  //   this.setState({ currentPage: listid }, () => {
  //     this.setState({
  //       pageStatus: false,
  //     });
  //     this.setPrevAndNextBtnClass(listid);
  //     this.getAuthorizationsList(
  //       false,
  //       this.state.currentPage,
  //       this.state.upperPageBound,
  //       this.state.lowerPageBound,
  //       this.state.pageBound,
  //       this.state.isPrevBtnActive,
  //       this.state.isNextBtnActive
  //     );
  //   });
  // };

  // btnPrevClick = () => {
  //   if ((this.state.currentPage - 1) % this.state.pageBound === 0) {
  //     this.setState({
  //       upperPageBound: this.state.upperPageBound - this.state.pageBound,
  //     });
  //     this.setState({
  //       lowerPageBound: this.state.lowerPageBound - this.state.pageBound,
  //     });
  //   }
  //   let listid = this.state.PageNumber - 1;
  //   this.setState({ PageNumber: listid }, () => {
  //     this.setState({
  //       pageStatus: false,
  //     });
  //     this.setPrevAndNextBtnClass(listid);
  //     this.getAuthorizationsList(
  //       this.state.PageNumber,
  //       // false,
  //       // this.state.currentPage,
  //       // this.state.upperPageBound,
  //       // this.state.lowerPageBound,
  //       // this.state.pageBound,
  //       // this.state.isPrevBtnActive,
  //       // this.state.isNextBtnActive
  //     );
  //   });
  // };

  // btnNextClick = () => {
  //   // console.log("currentPage",this.state.currentPage)
  //   // console.log("upperPageBound",this.state.upperPageBound)
  //   // console.log("pageBound",this.state.pageBound)
  //   if (this.state.currentPage + 1 > this.state.upperPageBound) {
  //     this.setState({
  //       upperPageBound: this.state.upperPageBound + this.state.pageBound,
  //     });
  //     this.setState({
  //       lowerPageBound: this.state.lowerPageBound + this.state.pageBound,
  //     });
  //   }
  //   let listid = this.state.PageNumber + 1;
  //   this.setState({ PageNumber: listid }, () => {
  //     this.setState({
  //       pageStatus: false,
  //     });
  //    // console.log("setPrevAndNextBtnClass",listid)
  //     this.setPrevAndNextBtnClass(listid);
  //     this.getAuthorizationsList(
  //      // false,
  //        this.state.PageNumber,
  //       // this.state.upperPageBound,
  //       // this.state.lowerPageBound,
  //       // this.state.pageBound,
  //       // this.state.isPrevBtnActive,
  //       // this.state.isNextBtnActive
  //     );
  //   });
  // };
  rowClick = (item) => {
    console.log("item",item)
    addTab.next({
      item: item,
      type: "ticket-details",
    });
  };
  paginationIncrement = () => {
    // if(this.state.totalRecords != this.state.currentPage){
    //     alert("hi")
    // }
    if (this.state.PageSize < 50) {
    this.setState(
      {
       // todosPerPage: this.state.PageSize + 10,
        pageStatus: false,
        PageSize: this.state.PageSize + 5,
      },

      () =>
        this.getAuthorizationsList(
          // this.setState({
          //   PageSize: this.state.PageSize + 10,
          // }),
          // false,
          // this.state.currentPage,
          // this.state.upperPageBound,
          // this.state.lowerPageBound,
          // this.state.pageBound,
          // this.state.isPrevBtnActive,
          // this.state.isNextBtnActive
        )
    )};
  };

  paginationDecrement = () => {
    if (this.state.PageSize > 15) {
      this.setState(
        {
       //   todosPerPage: this.state.todosPerPage - 10,
       PageSize: this.state.PageSize - 5,
          pageStatus: false,
        },
        () =>
          this.getAuthorizationsList(
            // false,
            // this.state.currentPage,
            // this.state.upperPageBound,
            // this.state.lowerPageBound,
            // this.state.pageBound,
            // this.state.isPrevBtnActive,
            // this.state.isNextBtnActive
          )
      );
    } else {
      this.setState(
        {
          todosPerPage: this.state.todosPerPage,
          pageStatus: false,
        },
        () =>
          this.getAuthorizationsList(
            false,
            this.state.currentPage,
            this.state.upperPageBound,
            this.state.lowerPageBound,
            this.state.pageBound,
            this.state.isPrevBtnActive,
            this.state.isNextBtnActive
          )
      );
    }
    // this.getAuthorizationsList(false, this.state.currentPage,this.state.upperPageBound,this.state.lowerPageBound,this.state.pageBound, this.state.isPrevBtnActive, this.state.isNextBtnActive)
  };
  setPrevAndNextBtnClass = (listid) => {
    console.log("list",listid)
    console.log("current")
    var totalPage;

    totalPage = this.state.totalRecords;

 //   this.setState({ PageNumber: listid+1})
    this.setState({ isNextBtnActive: 'disabled' });
    this.setState({ isPrevBtnActive: 'disabled' });
    if (totalPage === listid && totalPage > 1) {
        this.setState({ isPrevBtnActive: '' });
    }
    else if (listid === 1 && totalPage > 1) {
        this.setState({ isNextBtnActive: '' });
    }
    else if (totalPage > 1) {
        this.setState({ isNextBtnActive: '' });
        this.setState({ isPrevBtnActive: '' });
    }
}

btnIncrementClick = () => {
    this.setState({ upperPageBound: this.state.upperPageBound + this.state.pageBound });
    this.setState({ lowerPageBound: this.state.lowerPageBound + this.state.pageBound });
    let listid = this.state.upperPageBound + 1;
    this.setState({ currentPage: listid }, () => {
        this.getAuthorizationsList();
        this.setPrevAndNextBtnClass(listid);
    });
}

btnDecrementClick = () => {
    this.setState({ upperPageBound: this.state.upperPageBound - this.state.pageBound });
    this.setState({ lowerPageBound: this.state.lowerPageBound - this.state.pageBound });
    let listid = this.state.upperPageBound - 5;
    this.setState({ currentPage: listid }, () => {
        this.getAuthorizationsList();
        this.setPrevAndNextBtnClass(listid);
    });
}

btnPrevClick = () => {
    if ((this.state.currentPage - 1) % this.state.pageBound === 0) {
        this.setState({ upperPageBound: this.state.upperPageBound - this.state.pageBound });
        this.setState({ lowerPageBound: this.state.lowerPageBound - this.state.pageBound });
    }
    let listid = this.state.currentPage - 1;
    this.setState({
      PageNumber: listid,
    })
    this.setState({ currentPage: listid }, () => {
        this.getAuthorizationsList(listid)
        this.setPrevAndNextBtnClass(listid);
    });
}

btnNextClick = () => {
 // console.log("nextclck",lis)
    if ((this.state.currentPage + 1) > this.state.upperPageBound) {
        this.setState({ upperPageBound: this.state.upperPageBound + this.state.pageBound });
        this.setState({ lowerPageBound: this.state.lowerPageBound + this.state.pageBound });
    }
    let listid = this.state.currentPage + 1;
    this.setState({
      PageNumber: listid,
    })
    this.setState({ currentPage: listid }, () => {
        this.getAuthorizationsList();
        this.setPrevAndNextBtnClass(listid);
    });
}

handleClick = (number) => {
    let listid = Number(number);

    // let listid = Number(this.state.currentPage)
    this.setState({
      PageNumber: listid,
        currentPage: number,
        // todosPerPage: 20,
    }, () => {
        this.getAuthorizationsList();
        this.setPrevAndNextBtnClass(number);
    });
    // this.props.form.setFieldsValue({
    //     currentPage : number
    // })
    $("ul li.active").removeClass('active');
    $('ul li#' + listid).addClass('active');
}

// componentDidUpdate() {

//     $("ul li.active").removeClass('active');
//     $('ul li#' + this.state.currentPage).addClass('active');
//     // this.AdmissionListUpdatedbyEvents()
// }

incidentForChange = (value) => {
    this.setState({
        incidentCreatedForType: value
    })
}

callerTypeChange = (value, e) => {
    this.setState({
        inputCallerType: value
    })
}


  resetFields = () => {
    this.setState(
      {
        HitSearch: false,
        filterTicketID: "",
        filterTicketType: "",
        filterTicketStatus: "",
        filterCreatedBy: "",
        filterReq: "",
        filterAbv: "",
        filterReference: "",
        filterSubId: "",
        filterCreatedFor: "",
        filterCreatedForID: "",
        filterMemberName: "",
        filterCreatedDate: "",
        filterStatus: "",
        filterPos: "",
        filterAuth: "",
        filterMode: "",
        filterDx: "",
        currentPage: 1,
        todosPerPage: 10,
        // filterPageNumber : 1,
        pageStatus: false,
        totalPages: "",
        // currentPage: 1,
        // todosPerPage: 10,
        upperPageBound: 5,
        lowerPageBound: 0,
        isPrevBtnActive: "disabled",
        isNextBtnActive: "",
        pageBound: 1,
      },
      () => {
        this.getAuthorizationsList(true, 1, 5, 0, 1);
        this.props.form.setFieldsValue({
          filterCreatedDate: "",
        });
      }
    );
  };

  render() {
    console.log("HitSearch",this.state.HitSearch);
    // console.log("clickActive",this.props.clickActive);
    // console.log("selectedSidebar",this.props.selectedSidebar);

    if (this.state.authPage != "1" && this.state.authPage != "2") {
      this.state.memberDetailsSubscriberId = this.props.subId.SubscriberID;
    } else {
      this.state.memberDetailsSubscriberId = "";
    }
    const {
      currentPage,
      todosPerPage,
      upperPageBound,
      lowerPageBound,
      isPrevBtnActive,
      isNextBtnActive,
    } = this.state;

    const { getFieldDecorator } = this.props.form;
    // var currentTodos;
    this.state.filterData = this.state.authListData.filter((e) => {
    // console.log("aaa",e);
      var ticketID = 
      e.TicketID === null || e.TicketID === undefined ? "" : e.TicketID.toString().replace(/\s+/g, " ");
      var req =
        e.Req === null || e.Req === undefined ? "" : e.Req.replace(/\s+/g, " ");
        var ticketType =
        e.TicketType === null || e.TicketType === undefined ? "" : e.TicketType.replace(/\s+/g, " ");
        var createdBy =
        e.CreatedBy === null || e.CreatedBy === undefined ? "" : e.CreatedBy.replace(/\s+/g, " ");
        var ticketStatus =
        e.TicketStatus === null || e.TicketStatus === undefined ? "" : e.TicketStatus.replace(/\s+/g, " ");
      var abv =
        e.Abv === null || e.Abv === undefined ? "" : e.Abv.replace(/\s+/g, " ");
      var reference =
        e.Reference === null || e.Reference === undefined
          ? ""
          : e.Reference.replace(/\s+/g, " ");
      var createdFor =
        e.CreatedFor === null || e.CreatedFor === undefined
          ? ""
          : e.CreatedFor.replace(/\s+/g, " ");
      var createdForID =
        e.CreatedForID === null || e.CreatedForID === undefined
          ? ""
          : e.CreatedForID.replace(/\s+/g, " ");
      var createdDate =
        e.CreatedDate === null || e.CreatedDate === undefined ? "" : e.CreatedDate.replace(/\s+/g, " ");
      var status =
        e.Status === null || e.Status === undefined
          ? ""
          : e.Status.replace(/\s+/g, " ");
      var pos =
        e.POS === null || e.POS === undefined ? "" : e.POS.replace(/\s+/g, " ");
      var auth =
        e.Auth === null || e.Auth === undefined
          ? ""
          : e.Auth.replace(/\s+/g, " ");
      var mode =
        e.Mode === null || e.Mode === undefined
          ? ""
          : e.Mode.replace(/\s+/g, " ");
      var dx =
        e.DX === null || e.DX === undefined ? "" : e.DX.replace(/\s+/g, " ");

      if (this.state.searchColumn) {
        
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterReq.toLocaleLowerCase());
      } else if (this.state.searchColumn) {  //filterTicketType
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterTicketID.toLocaleLowerCase());
      } else if (this.state.searchColumn) {  //filterTicketType   filterCreatedBy filterTicketStatus
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterTicketType.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterCreatedBy.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterTicketStatus.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAbv.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterReference.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterCreatedFor.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterCreatedForID.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterCreatedDate.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterStatus.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterPos.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAuth.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterMode.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterDx.toLocaleLowerCase());
      }
      const { currentPage, upperPageBound, lowerPageBound, isPrevBtnActive, isNextBtnActive } = this.state
      const { getFieldDecorator } = this.props.form;
  
      return (  //filterCreatedBy  filterTicketStatus
        ticketID.toLowerCase().includes(this.state.filterTicketID.toLowerCase()) &&
        ticketType.toLowerCase().includes(this.state.filterTicketType.toLowerCase()) &&
        createdBy.toLowerCase().includes(this.state.filterCreatedBy.toLowerCase()) &&
        ticketStatus.toLowerCase().includes(this.state.filterTicketStatus.toLowerCase()) &&
        req.toLowerCase().includes(this.state.filterReq.toLowerCase()) &&
        abv.toLowerCase().includes(this.state.filterAbv.toLowerCase()) &&
        reference
          .toLowerCase()
          .includes(this.state.filterReference.toLowerCase()) &&
        createdFor.toLowerCase().includes(this.state.filterCreatedFor.toLowerCase()) &&
        createdForID
          .toLowerCase()
          .includes(this.state.filterCreatedForID.toLowerCase()) &&
        createdDate.toLowerCase().includes(this.state.filterCreatedDate.toLowerCase()) &&
        status.toLowerCase().includes(this.state.filterStatus.toLowerCase()) &&
        pos.toLowerCase().includes(this.state.filterPos.toLowerCase()) &&
        auth.toLowerCase().includes(this.state.filterAuth.toLowerCase()) &&
        mode.toLowerCase().includes(this.state.filterMode.toLowerCase()) &&
        dx.toLowerCase().includes(this.state.filterDx.toLowerCase())
      );
    });

    // const { currentPage, upperPageBound, lowerPageBound, isPrevBtnActive, isNextBtnActive } = this.state
    // const { getFieldDecorator } = this.props.form;



    // const indexOfLastTodo = currentPage * todosPerPage;
    // const indexOfFirstTodo = indexOfLastTodo - todosPerPage;

    const Page = [];

    for (let i = 1; i <= this.state.totalRecords; i++) {
        Page.push(i);
    }

    const renderPage = Page.map((number, index) => {
        if (number === 1 && currentPage === 1) {
            return (
                <div>
                    <li key={number} className='active' id={number} onClick={() => this.handleClick(number)}><a key={index} href='#' id={number} >{number}</a></li>
                </div>
            )
        }
        else if ((number < upperPageBound + 1) && number > lowerPageBound) {
            return (
                <li id={number} key={number} onClick={() => this.handleClick(number)}><a key={index} href='#' id={number} >{number}</a></li>
            )
        }
    });

    let pageIncrementBtn = null;
    if (Page.length > upperPageBound) {
        pageIncrementBtn = <li className=''><a href='#' onClick={this.btnIncrementClick}> &hellip; </a></li>
    }
    let pageDecrementBtn = null;
    if (lowerPageBound >= 1) {
        pageDecrementBtn = <li className=''><a href='#' onClick={this.btnDecrementClick}> &hellip; </a></li>
    }
    let renderPrevBtn = null;
    if (isPrevBtnActive === 'disabled') {
        renderPrevBtn = <li className="isPrevBtnActive pageDisabled"><img src={PreviousIcon} alt="Left Arrow" /></li>
    }
    else {
        renderPrevBtn = <li className="isPrevBtnActive" onClick={this.btnPrevClick}><img src={PreviousIcon} alt="Left Arrow" id="btnPrev" /></li>
    }
    let renderNextBtn = null;
    if (isNextBtnActive === 'disabled') {
        renderNextBtn = <li className="isNextBtnActive pageDisabled"><img src={NextIcon} alt="Right Arrow" /></li>
    } else if (this.state.currentPage === 1 && this.state.totalPages === 1) {
        renderNextBtn = <li className="isNextBtnActive pageDisabled"><img src={NextIcon} alt="Right Arrow" /></li>
    }
    else {
        renderNextBtn = <li className="isNextBtnActive " onClick={this.btnNextClick}><img src={NextIcon} alt="Right Arrow" id="btnNext" /></li>
    }

    return (
             <div>
        {this.props.fromPage && (
          <div>
            {/* <ErrorBoundaries>
            <AddEventBlock
              uniqueId={this.props.uniqueId}
              dataCount={this.state.filterData.length}
              tabName="Auth"
              userDetails={this.props.memberDetails}
              callerId={this.props.callerId}
              activeKey={this.props.activeKey} filterTicketID
            />
            </ErrorBoundaries> */}
          </div>
        )}
        <div className="mydiv">
          <table className="authTable authTable1">{this.tableHeader()}</table>
          {(this.state.filterTicketID != null && this.state.filterTicketID != "") ||
          (this.state.filterTicketType != null && this.state.filterTicketType != "") ||
          (this.state.filterCreatedBy != null && this.state.filterCreatedBy != "") ||
          (this.state.filterTicketStatus != null && this.state.filterTicketStatus != "") ||
          (this.state.filterCreatedFor != null && this.state.filterCreatedFor != "") ||
          (this.state.filterCreatedForID != null && this.state.filterCreatedForID != "") ||
          (this.state.filterCreatedDate != null && this.state.filterCreatedDate != "") ||
          // (this.state.filterReq != null && this.state.filterReq != "") ||
          //   (this.state.filterAbv != null && this.state.filterAbv != "") ||
          //   (this.state.filterReference != null &&
          //     this.state.filterReference != "") ||
          //   (this.state.filterSubId != null && this.state.filterSubId != "") ||
          //   (this.state.filterMemberName != null &&
          //     this.state.filterMemberName != "") ||
          //   (this.state.filterCreatedDate != null && this.state.filterCreatedDate != "") ||
          //   (this.state.filterStatus != null && this.state.filterStatus != "") ||
          //   (this.state.filterPos != null && this.state.filterPos != "") ||
          //   (this.state.filterAuth != null && this.state.filterAuth != "") ||
            (this.state.filterMode != null && this.state.filterMode != "") ||
            (this.state.filterDx != null && this.state.filterDx != "") ? (
            <div className="AuthpositionRight">
              <span className="authCrossButtonBg" onClick={this.resetFields}>
                <img
                  className="actionButtons"
                  src={CrossIcon}
                  style={{ width: "11px", height: "11px" }}
                />
              </span>
              <span
                className="authSearchButtonBg"
                onClick={() =>
                  this.getAuthorizationsList(true, 1, 5, 0, 1, "disabled", "", this.setState({HitSearch: true}))
                }
              >
                <img
                  className="actionButtons"
                  src={SearchIcon}
                  width="13"
                  height="13"
                />
              </span>
            </div>
          ) : (
            ""
          )}

          <table className="authTable authTable1">
            <tbody className="tableBody">
              {this.state.filterData.length > 0 &&
                this.state.authListLoading === true &&
                this.state.filterData.map((user, index) => {
                  if (index <= 8) {
                    var serialNumber = "0" + (index + 1);
                  } else {
                    var serialNumber = index + 1;
                  }
                  // var date = user.CreatedDate.split( "T" )[0];
                  // var d_arr = date.split("-");
                  // var newdate = d_arr[1] + '-' + d_arr[2] + '-' + d_arr[0];
                  // {{console.log("date for date",(user.CreatedDate.split( "T" )[0]))}}      
                  // this.state.serialNumber = this.state.todosPerPage * (this.state.currentPage - 1) + index + 1
                  return (             
                    <tr key={index} onClick={() => {this.rowClick(user)}}>
                      {/* <td>{this.state.todosPerPage * (this.state.currentPage - 1) + index + 1}.</td> */}
                      <Tooltip title={serialNumber}><td>{serialNumber}</td></Tooltip>
                      <Tooltip title={user.CreatedDate}><td>
                        {user.CreatedDate}
                      </td></Tooltip>
                      <Tooltip title={user.TicketID}><td>{user.TicketID}</td></Tooltip>
                      <Tooltip title={user.TicketType}><td>{user.TicketType ? user.TicketType : "---"}</td></Tooltip>
                      <Tooltip title={user.CreatedFor}><td>{user.CreatedFor ? user.CreatedFor : "---"}</td></Tooltip>
                      <Tooltip title={user.CreatedForID}><td>{user.CreatedForID ? user.CreatedForID : "---"}</td></Tooltip>
                      <Tooltip title={user.CreatedBy}><td>{user.CreatedBy ? user.CreatedBy : "---"}</td></Tooltip>
                      <Tooltip title={user.TicketStatus}><td>{user.TicketStatus ? user.TicketStatus : "---"}</td></Tooltip>
                      {/* <td>{user.POS}</td>
                      <td>{user.Auth}</td>
                      <td>{user.Mode}</td>
                      <td>{user.DX}</td> */}
                    </tr>
                  
                  );
                })}
            </tbody>
          </table>
          {this.state.filterData.length === 0 &&
            this.state.authListLoading === false && (
              <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                <Spin size="large" tip="Loading..." />
              </div>
            )}
          {this.state.filterData.length === 0 &&
            this.state.authListLoading === true && (
              <div className="mt-5 mb-5 h6 d-flex justify-content-center">
               
                <span>{this.state.HitSearch == true ? "No tickets found for the search, please change the parameters and try again.": "This queue does not have any tickets, to create a ticket goto respective profile to find a Create Ticket option."}</span>
              
              </div>
            )}
        </div>
        {/* {this.state.filterData.length > 0 && ( */}
          <div className="page-bottom" style={{ marginTop: "8px" }}>
            {/* {this.state.totalRecordFound > 10 ? ( */}
              <ul
                className="pagination"
                style={{ margin: "0px", padding: "0px" }}
              >
                {renderPrevBtn}
                {pageDecrementBtn}
                {renderPage}
                {pageIncrementBtn}
                {renderNextBtn}
              </ul>
            {/* ) : (
              <div></div>
            )} */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div>
                {/* {this.state.totalRecordFound > 10 ? ( */}
                  <div className="page-bottom-pagination-buttons">
                    <button
                      className="page-bottom-buttons"
                      onClick={this.paginationIncrement}
                    >
                      <img
                        src={paginationIncrement}
                        alt="IncrementIcon"
                        style={{
                          width: "9px",
                          height: "9px",
                          marginLeft: "-2px",
                          marginTop: "-2px",
                        }}
                      />
                    </button>
                    <span className="page-bottom-buttons-text ">
                      <b>{this.state.PageSize}</b>
                      <b>Rows</b>
                    </span>
                    <button
                      className="page-bottom-buttons"
                      onClick={this.paginationDecrement}
                    >
                      <img
                        src={paginationDecrement}
                        alt="DecrementIcon"
                        style={{
                          width: "9px",
                          marginLeft: "-2px",
                          marginTop: "-2px",
                        }}
                      />
                    </button>
                  </div>
                {/* ) : (
                  <div></div>
                )} */}
              </div>
              {/* <div style={{ marginLeft: "8px", marginRight: "12px" }}>
                <button
                  className="page-bottom-downolad-button"
                  type="submit"
                  onClick={() =>
                    this.getAuthorizationsList(
                      "downloadExcel",
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                >
                  <img
                    src={DownloadIcon}
                    alt="downloadIcon"
                    className="page-bottom-download-icon"
                  />
                  <span className="page-bottom-download-text">Download</span>
                </button>
              </div> */}
            </div>
          </div>
        {/* )} */}
      </div>
    );
  }
}

//export default TicketTableData;
export default Form.create({ name: "TicketTableData" })(TicketTableData);
